module.exports = __webpack_public_path__ + "img/table.be5030ca.webp";